export default {
  border: 'none',
  backgroundColor: 'transparent',
  outline: 'none',

  cursor: 'pointer',

  color: 'inherit',
  padding: 'initial',
	textTransform: 'inherit',
};
